import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import { motion, AnimatePresence } from "motion/react";
import img1 from "../../assets/heroImg1.jpg";
import img2 from "../../assets/heroImg2.jpg";
import img3 from "../../assets/heroImg3.jpg";
import img4 from "../../assets/heroImg4.jpg";
import imgm1 from "../../assets/MobileheroImg1.jpg";
import imgm2 from "../../assets/MobileheroImg2.jpg";
import imgm3 from "../../assets/MobileheroImg3.jpg";


const ease = [0.22, 1, 0.36, 1];

const backgroundImages = [img1, img2, img4, img3];

const MobilebackgroundImages = [imgm1, imgm2, imgm3, img4];


export default function Hero() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative md:min-h-[85vh] h-[500px] flex items-center justify-start overflow-hidden">
      {/* Desktop Background Slider */}
      <div className="absolute md:flex hidden inset-0 z-0">
        <AnimatePresence initial={false}>
          <motion.img
            key={currentImageIndex}
            src={backgroundImages[currentImageIndex]}
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.5, ease: "easeInOut" }}
            className="absolute inset-0 w-full h-full object-cover"
            alt="Ayurvedic Clinic Background"
          />
        </AnimatePresence>

        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent z-10" />
      </div>

      {/* Mobilw Background Slider */}
      <div className="absolute md:hidden flex inset-0 z-0">
        <AnimatePresence initial={false}>
          <motion.img
            key={currentImageIndex}
            src={MobilebackgroundImages[currentImageIndex]}
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.5, ease: "easeInOut" }}
            className="absolute inset-0 w-full h-full object-cover"
            alt="Ayurvedic Clinic Background"
          />
        </AnimatePresence>

        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent z-10" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 w-full">
        <div className="max-w-3xl">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1, transition: { staggerChildren: 0.2 } },
            }}
            className="flex flex-col gap-6"
          >
            <motion.div variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease } } }}>
              <span className="inline-block text-brand-gold text-sm md:text-base font-bold uppercase tracking-widest">
                Welcome To
              </span>
            </motion.div>

            <motion.h1
              variants={{ hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease } } }}
              className="text-4xl sm:text-5xl lg:text-7xl leading-[1.1] font-bold text-white tracking-tight"
            >
              Veda Nova
            </motion.h1>

            <motion.p
              variants={{
                hidden: { opacity: 0, y: 20 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: { duration: 0.8, ease },
                },
              }}
              className="inline-block text-brand-gold text-sm md:text-base font-bold uppercase tracking-widest leading-relaxed"
            >
              Every journey begins with hope <br />
              every hope deserves the right beginning
            </motion.p>

            <motion.div
              variants={{ hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease } } }}
              className="flex flex-wrap gap-4 mt-4"
            >
              {/* <Link to="/doctors">
                <Button
                  size="large"
                  className="!bg-white !text-brand-forest !font-bold !border-none !h-auto !px-8 !py-3 !rounded-full !shadow-xl hover:!bg-brand-beige"
                >
                  Meet our doctor
                </Button>
              </Link> */}
              <a href="tel:+91 90281 56566 ">
                <Button
                  size="large"
                  ghost
                  className="!border-2 !border-white !text-white !font-bold !h-auto !px-8 !py-3 !rounded-full hover:!bg-white/10"
                >
                  Call Us +91 90281 56566
                </Button>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
